import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Endpoints whose own 401 must NOT trigger a refresh-retry (avoids loops / wrong-password retries).
const NO_REFRESH = ["/auth/refresh", "/auth/login", "/auth/admin-login", "/auth/logout"];

// Single in-flight refresh shared across concurrent 401s.
let refreshPromise = null;

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    const url = original.url || "";
    const isAuthFlow = NO_REFRESH.some((p) => url.includes(p));

    if (status === 401 && !original._retry && !isAuthFlow) {
      original._retry = true;
      try {
        // If the access token expired but a valid refresh token cookie exists,
        // securely mint a new access token (httpOnly cookies, no localStorage).
        refreshPromise = refreshPromise || api.post("/auth/refresh");
        await refreshPromise;
        refreshPromise = null;
        return api(original); // replay the original request with the refreshed cookie
      } catch (refreshErr) {
        refreshPromise = null;
        return Promise.reject(refreshErr);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
